import React from 'react';
import Vendor from '../../../models/Vendor';
import Pagination from '../../../models/Pagination';
import { Table, TableBody, TableCell, TableHead, TableRow, CircularProgress, Stack } from '@mui/material';
import PaginationButtons from '../../PaginationButtons';
import { ISTableTitle, ISTableHeaderCell, ISTableRow } from '../../Utils/ISTable';
import { useTranslation } from 'react-i18next';
import LinkedVendors from '../../../models/LinkedVendors';

export interface Row {
  data: Vendor
  action?: 'create' | 'update' | 'error';
}

interface Props {
  rows: Row[];
  linkedVendors: LinkedVendors[]
  loading: boolean;
  linkedVendorFilter?: string;
  pagination?: Pagination;
  onChangePage?: (page: number) => void;
  onClickInfo?: (vendor: Vendor) => void;
}

const Vendors: React.FC<Props> = (props) => {
  const { t } = useTranslation('vendor')

  const mapActionToColor = (action?: string) => {
    switch (action) {
      case 'create': return 'green';
      case 'update': return 'yellow';
      case 'error': return 'red';
      default: return 'default';
    }
  }

  const rowsToShow = !props.linkedVendorFilter ? props.rows : (props.linkedVendors.filter(lv => lv.personId === Number(props.linkedVendorFilter))
  .map(lv => props.rows.find(row => row.data.codigo_vendedor === lv.vendorId))
  .filter(Boolean))

  return (
    <Stack style={{ display: 'flex', flexDirection: 'column', borderRadius: "10px", margin: "10px", minWidth: "770px" }}>
      <ISTableTitle title={t('title')} />
      <Table style={{whiteSpace:"nowrap", overflow:"hidden"}} size="medium" >
        <TableHead >
          <TableRow selected={true}>
            <ISTableHeaderCell align='right'>{t('code')}</ISTableHeaderCell>
            <ISTableHeaderCell>{t('name')}</ISTableHeaderCell>
            <ISTableHeaderCell>{t('assignedTo')}</ISTableHeaderCell>
            <ISTableHeaderCell>{t('assignedVendor')}</ISTableHeaderCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {!props.loading && rowsToShow.length > 0 && rowsToShow.map((row, index) => row &&
            <ISTableRow key={index} color={mapActionToColor(row.action)} sx={{ cursor: 'pointer' }}
              onClick={(e) => { e.stopPropagation(); props.onClickInfo && props.onClickInfo(row.data) }}>
              <TableCell align='right'>{row.data.codigo_vendedor}</TableCell>
              <TableCell>{row.data.nombre}</TableCell>
              <TableCell>{props.linkedVendors.filter( lv => lv.vendorId === row.data.codigo_vendedor && lv.personType === 'H' ).map( name => name.personName ).join(', ')}</TableCell>
              <TableCell>{props.linkedVendors.filter( lv => lv.vendorId === row.data.codigo_vendedor && lv.personType === 'V' ).map( name => name.personName ).join(', ')}</TableCell>
            </ISTableRow>
          )}
        </TableBody>
      </Table>
      {props.loading &&
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <CircularProgress size={25} />
        </div>
      }
      <PaginationButtons pagination={props.pagination} />
    </Stack>
  );
}

export default Vendors
